import React, { useState, useEffect, useCallback } from 'react';
import { debounce } from '../../utils/helpers';

/**
 * Input component that updates immediately in UI but debounces parent updates
 * Prevents character dropping while typing
 */
const DebouncedInput = ({ 
  value: externalValue, 
  onChange, 
  delay = 1200,
  disabled = false,
  className = '',
  placeholder = '',
  type = 'text',
  ...props 
}) => {
  // Local state for immediate UI updates
  const [localValue, setLocalValue] = useState(externalValue || '');

  // Sync with external value changes (from other sources)
  useEffect(() => {
    setLocalValue(externalValue || '');
  }, [externalValue]);

  // Debounced callback to parent
  const debouncedOnChange = useCallback(
    debounce((value) => {
      onChange(value);
    }, delay),
    [onChange, delay]
  );

  // Handle local change
  const handleChange = (e) => {
    const newValue = e.target.value;
    
    // ✅ INSTANT local update (no lag)
    setLocalValue(newValue);
    
    // ✅ Debounced parent update
    debouncedOnChange(newValue);
  };

  return (
    <input
      type={type}
      value={localValue}
      onChange={handleChange}
      disabled={disabled}
      className={className}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default DebouncedInput;